import React, { Fragment, ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { Header, Footer } from "@/components";
import { RoutesPathList } from "@/config/routes/Routes";
import { isBitramp } from "@/utils/utils";

interface Props {
  children: ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  // const isLeonextExchange = window.location.hostname === "leonext.exchange";

  const routesWithHeader = [
    !isBitramp() && RoutesPathList.Landing,
    RoutesPathList.Solutions,
    RoutesPathList.About,
    RoutesPathList.Faq,
    RoutesPathList.Contact,
    RoutesPathList.Blog,
    RoutesPathList.TOU,
    RoutesPathList.WPP,
  ];

  const routesWithFooter = [...routesWithHeader];

  return (
    <Fragment>
      {routesWithHeader.includes(location.pathname as RoutesPathList) && (
        <Header />
      )}
      {children}
      {routesWithFooter.includes(location.pathname as RoutesPathList) && (
        <Footer />
      )}
    </Fragment>
  );
};

export default Layout;
